var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64415 18.3863L2.90348 20.0586C2.73539 20.2201 2.64038 20.4431 2.64038 20.6762C2.64038 21.1493 3.02384 21.5327 3.49687 21.5327H20.5031C20.9762 21.5327 21.3596 21.1493 21.3596 20.6762C21.3596 20.4431 21.2646 20.2201 21.0965 20.0586L19.3559 18.3863C19.1596 18.1977 19.0487 17.939 19.0487 17.6668V11.2915C19.0487 8.54187 18.0029 4.51953 12 4.51953C5.99714 4.51953 4.95134 8.67654 4.95134 11.2915V17.6664C4.95134 17.9385 4.84041 18.1977 4.64415 18.3863Z",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56128 4.51953C9.56128 2.75115 10.3806 1.48945 12.0001 1.4895C13.6197 1.48955 14.4388 2.7374 14.4388 4.51953",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 25C13.3385 25 14.1304 24.0139 14.3649 22.5294C14.4511 21.9839 13.9911 21.5327 13.4388 21.5327H10.5613C10.009 21.5327 9.54901 21.9839 9.63435 22.5295C9.8678 24.0223 10.6599 25 12 25Z",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/NotificationsIcon.74f69d109d5bb009baae6ea5a8b40aea.svg";
export { ForwardRef as ReactComponent };